import React from 'react';
import { Info } from 'lucide-react';
import type { BodyEndData } from './types';

interface InlineScriptsTabProps {
  formData: BodyEndData;
  onInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const InlineScriptsTab: React.FC<InlineScriptsTabProps> = ({ formData, onInputChange }) => (
  <div className="space-y-4">
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <div className="flex items-start space-x-2">
        <Info size={20} className="text-blue-600 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-blue-800">
          <p className="font-medium mb-1">Inline Scripts</p>
          <p>
            Add custom JavaScript code that will be executed at the end of the page body. Useful for
            analytics, tracking pixels, or custom functionality.
          </p>
        </div>
      </div>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">JavaScript Code</label>
      <textarea
        name="inlineScripts"
        value={formData.inlineScripts}
        onChange={onInputChange}
        rows={12}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent font-mono text-sm"
        placeholder="// Add your JavaScript code here&#10;console.log('Hello from Scripts & Widgets!');"
      />
      <p className="mt-2 text-sm text-gray-500">
        Do not include &lt;script&gt; tags - they will be added automatically.
      </p>
    </div>
  </div>
);
